import type { MonsterTokenStyle } from '../api';

export const gameIconSources = {
  clue: ['/Clue.jpg', '/Clue.png'],
  money: ['/money.jpg', '/money.png'],
  terror: ['/TerrorTrack.png'],
  heart: ['/stamina.png'],
  brain: ['/sanity.png'],
  patrol: ['/patrol.png'],
  'ancient-whisper': ['/AncientWhisper.jpg'],
  bast: ['/Guardians/BastToken.jpg'],
  eihort: ['/AncientOnes/EihortToken.jpg'],
  zhar: [],
  activity: ['/activity.png'],
  'elder-sign': ['/ElderSign.jpg'],
  'ancient-eye': ['/eye.jpg'],
} as const;

export type GameIcon = keyof typeof gameIconSources;
export const digitalGameIconPath = (icon: GameIcon) => `/icons/digital/${icon}.webp`;

export function getGameIconArtworkPath(source: string, style: MonsterTokenStyle): string {
  if (style === 'Classic') return source;
  const icon = (Object.keys(gameIconSources) as GameIcon[]).find(key =>
    (gameIconSources[key] as readonly string[]).includes(source));
  return icon ? digitalGameIconPath(icon) : source;
}
